<div id="userProfileDetail" class="profileDetail-container ya-typography">
  <ya-subheader [hasContent]="true">
    <div class="menu-header-container">
      <mat-tab-group id="headerTabs" mat-stretch-tabs id="headerTabs" [(selectedIndex)]="currentHeaderIndex"
        animationDuration="20ms" (selectedTabChange)="headerTabIndexChange($event)"
        (focusChange)="headerTabFocusChange($event)"
        class="ya-tab-group ya-tab-group--bodyless ya-tab-group--notStretch">
        <mat-tab>
          <ng-template mat-tab-label>
            <span langkey="phUserProfileDetail_Tab_Header_AccounntInfo"></span>
          </ng-template>
        </mat-tab>

        <mat-tab>
          <ng-template mat-tab-label>
            <span langkey="phUserProfileDetail_Tab_Header_Order"></span>
          </ng-template>
        </mat-tab>

        <mat-tab>
          <ng-template mat-tab-label>
            <span langkey="phUserProfileDetail_Tab_Header_Addresses"></span>
          </ng-template>
        </mat-tab>
        <ng-container *ngIf="isItemTagEnabled">
          <mat-tab>
            <ng-template mat-tab-label>
              <span langkey="phUserProfileDetail_Tab_Header_Preferences"></span>
            </ng-template>
          </mat-tab>
        </ng-container>
        <ng-container *ngIf="isAccountPaymentTabVisible">
          <mat-tab>
            <ng-template mat-tab-label>
              <span langkey="phAccountPayment_SectionLabel"></span>
            </ng-template>
          </mat-tab>
        </ng-container>
      </mat-tab-group>
    </div>
  </ya-subheader>
  <div class="ya-page-content ya-page-content--padding ya-page-content--webshop"
    (swipeleft)="handleSwipeLeftGesture($event)" (swiperight)="handleSwipeRightGesture($event)">
    <mat-tab-group mat-stretch-tabs [(selectedIndex)]="currentHeaderIndex" animationDuration="20ms"
      class="ya-headerless-tab-group">
      <mat-tab>
        <ng-template matTabContent>
          <div class="ya-tab-content-wrapper user-details">
            <div class="ya-form-control-container">
              <ya-dynamicFormFields #dynamicFormFieldsComponent
                *ngIf="userInfoFieldsViewModel && userInfoFieldsViewModel.length > 0"
                [customerFieldsConfig]="userInfoFieldsViewModel" [initialData]="getUserInfoInitialData()"
                (formStatusChange)="onFormStatusChange()" (formReady)="disableEmailFormField()">
              </ya-dynamicFormFields>
            </div>
            <div class="ya-webshop-button-container">
              <ng-container *ngIf="isDynamicFormGroupValid() then activeButton else deactiveButton">
              </ng-container>
              <ng-template #activeButton>
                <button mat-flat-button (click)="saveUserInfo(false)"><span
                    langkey="phUserProfileDetail_Save_User_Info"></span></button>
              </ng-template>
              <ng-template #deactiveButton>
                <span (click)="markAllFieldsAsTouched()">
                  <button mat-flat-button disabled><span langkey="phUserProfileDetail_Save_User_Info"></span></button>
                </span>
              </ng-template>
              <div class="ya-button-container delete-button">
                <button mat-button [ngClass]="'mat-button ya-caption no-hover'" (click)="openDeleteDialog()">
                  <span class="delete-span" langkey="phUserProfileDetail_Delete_Account"></span>
                </button>
              </div>
            </div>
          </div>
        </ng-template>
      </mat-tab>
      <!--ORDER HISTORY-->
      <mat-tab>
        <ng-container *ngIf="!isOrderListEmpty then matTabContent else emptyOrderTemplate"> </ng-container>
        <ng-template #matTabContent>
          <div class="icon-list-container">
            <div class="dropdown-container">
              <div class="input-container-flex">
                <select a11y_Select class="ya-input-text" [(ngModel)]="selectedYear"
                  (change)="onYearSelectionChange($event)">
                  <ng-container *ngFor="let orderyear of yearList">
                    <option [value]="orderyear">
                      {{orderyear}}</option>
                  </ng-container>
                </select>
                <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-pfeil-unten-voll"></div>
              </div>
            </div>
            <div class="order-container">
              <ng-container *ngFor="let order of ordersOfSelectedYear">
                <div a11y_Button class="ya-icon-button service-button" (click)="navigateToOrderDetail(order.id)">
                  <div class="icon-container">
                    <div class="inline-icon" inlineSVG={{getOrderTypeIcon(order.order_type)}}>
                    </div>
                  </div>
                  <div class="content-container">
                    <div class="orderInformation-header">
                      <h2 class="title" langkey="phUserProfileDetail_Order_List_Header"></h2>
                      <h2 class="title">{{formatDate(order.order_at_ymd)}}</h2>
                    </div>
                    <div class="orderInformation">
                      <div class="order-text content-container--subfont" langkey="phUserProfileDetail_Order_Location">
                      </div>
                      <div class="order-text  content-container--subfont"> {{order.loc_label_de}} </div>
                    </div>
                    <div class="orderInformation">
                      <div class="order-text content-container--subfont" langkey="phUserOrderDetail_Order_Service">
                      </div>
                      <div class="order-text content-container--subfont">{{getOrderTypeLabel(order.order_type)}}</div>
                    </div>
                    <div class="orderInformation">
                      <div class="order-text content-container--subfont" langkey="phUserProfileDetail_Order_Amount">
                      </div>
                      <div class="amount-content">
                        <div class="order-text content-container--subfont"> {{formatCurrency(order.payment_amount)}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </ng-template>
        <ng-template #emptyOrderTemplate>
          <ya-emptypage emptyContent="phUserProfileDetail_Empty_Order"></ya-emptypage>
        </ng-template>
      </mat-tab>
      <!--ADDRESSES-->
      <mat-tab>
        <ng-template matTabContent>
          <div class="ya-tab-content-wrapper">
            <div class="title-alignment">
              <h2 langkey="phUserProfileDetail_Billing_Address"></h2>
            </div>
            <div class="icon-list-container">
              <div a11y_Button class="ya-icon-button service-button" (click)="navigateToEditBillingInfoAddress()">
                <div class="icon-container">
                  <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-adressen"></div>
                </div>
                <div class="content-container">
                  <div class="text content-container--subfont">{{userDetailInfoViewModel.co + " " +
                    userDetailInfoViewModel.address}}</div>
                  <div class="text content-container--subfont">
                    {{buildFormattedAddressString(userDetailInfoViewModel.zip_code,
                    userDetailInfoViewModel.city)}}</div>
                </div>
              </div>
            </div>
            <div class="deliveryaddress-title-wrapper title-alignment">
              <h2 langkey="phUserProfileDetail_Delivery_Address"></h2>
            </div>
            <div class="icon-list-container">
              <ng-container
                *ngIf="userDetailInfoViewModel.furtherAddress && userDetailInfoViewModel.furtherAddress.length > 0">
                <ng-container *ngFor="let deliveryAddress of userDetailInfoViewModel.furtherAddress">
                  <div a11y_Button class="ya-icon-button service-button"
                    (click)="navigateToEditAddress(userAddressType.OldDeliveryAddress, deliveryAddress)">
                    <div class="icon-container">
                      <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-adressen"></div>
                    </div>
                    <div class="content-container">
                      <div class="text content-container--subfont">{{buildFormattedAddressString(deliveryAddress.co,
                        deliveryAddress.address)}}</div>
                      <div class="text content-container--subfont">
                        {{buildFormattedAddressString(deliveryAddress.zip_code,
                        deliveryAddress.city)}}</div>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </div>
            <div class="botton-wrapper">
              <div class="ya-webshop-button-container">
                <button mat-flat-button (click)="navigateToEditAddress(userAddressType.NewDeliveryAddress)"><span
                    langkey="phUserProfileDetail_Botton_Label_NewAddress"></span></button>
              </div>
            </div>
          </div>
        </ng-template>
      </mat-tab>
      <ng-container *ngIf="isItemTagEnabled">
        <!--PREFERENCES-->
        <mat-tab>
          <ng-template matTabContent>
            <div class="ya-tab-content-wrapper">
              <div class="user-tag-container">
                <div class="tag-description-container">
                  <div class="title-alignment">
                    <h2 langkey="phUserProfileDetail_Tags_Title"></h2>
                  </div>
                  <div class="content-message">
                    <span langkey="phUserProfileDetail_Tags_Subtext"></span>
                  </div>
                </div>
                <div class="tag-gradiant-container">
                  <div class="item-tag-wrapper" (scroll)="isSmallView && handleTagListScrollEvent($event)">
                    <div class="item-tag-container">
                      <ng-container *ngFor="let itemTag of itemTags">
                        <div class="tag-wrapper">
                          <ng-container *ngIf="itemTagType === tagType.Icon; then iconTagTemplate else textTagTemplate">
                          </ng-container>
                          <ng-template #iconTagTemplate>
                            <div class="tag-icon-container">
                              <div class="inline-icon" [innerHTML]="svgSanitizer(itemTag.svgIcon)"></div>
                              <div class="tag-label">{{itemTag.label}}</div>
                            </div>
                          </ng-template>
                          <ng-template #textTagTemplate>
                            <div class="tag-label-container">
                              <span class="tag-label">{{itemTag.label}}</span>
                            </div>
                          </ng-template>
                          <div class="tag-selection-wrapper">
                            <a matRipple matRippleCentered="true"
                              [ngClass]="itemTag.itemTagStatus === itemTagStatus.like ? 'item-status-active' : ''"
                              (click)="setItemTagStatus(itemTag, itemTagStatus.like)">
                              <div class="inline-icon" inlineSVG="shop-icons.svg#ya-thumb-up"></div>
                            </a>
                            <a matRipple matRippleCentered="true"
                              [ngClass]="itemTag.itemTagStatus === itemTagStatus.dislike ? 'item-status-active' : ''"
                              (click)="setItemTagStatus(itemTag, itemTagStatus.dislike)">
                              <div class="inline-icon" inlineSVG="shop-icons.svg#ya-thumb-down"></div>
                            </a>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                    <ng-container *ngIf="!isSmallView">
                      <div class="botton-wrapper">
                        <div class="ya-webshop-button-container">
                          <ng-container *ngIf="isOnline  && isButtonActive; then activeButton else deactiveButton">
                          </ng-container>
                          <ng-template #activeButton>
                            <button mat-flat-button (click)="saveUserTags()"><span
                                langkey="phUserProfileDetail_Save_User_Info"></span></button>
                          </ng-template>
                          <ng-template #deactiveButton>
                            <button mat-flat-button disabled><span
                                langkey="phUserProfileDetail_Save_User_Info"></span></button>
                          </ng-template>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                  <ng-container *ngIf="isSmallView && showGradient">
                    <div class="content-gradient"></div>
                  </ng-container>
                </div>
                <ng-container *ngIf="isSmallView">
                  <div class="botton-wrapper">
                    <div class="ya-webshop-button-container">
                      <ng-container *ngIf="isOnline  && isButtonActive; then activeButton else deactiveButton">
                      </ng-container>
                      <ng-template #activeButton>
                        <button mat-flat-button (click)="saveUserTags()"><span
                            langkey="phUserProfileDetail_Save_User_Info"></span></button>
                      </ng-template>
                      <ng-template #deactiveButton>
                        <button mat-flat-button disabled><span
                            langkey="phUserProfileDetail_Save_User_Info"></span></button>
                      </ng-template>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-template>
        </mat-tab>
      </ng-container>
      <!-- Account Payment Tab -->
      <ng-container *ngIf="isAccountPaymentTabVisible">
        <mat-tab>
          <ng-template matTabContent>
            <div class="ya-tab-content-wrapper">
              <div class="account-payment-profile__tab-content">
                <h2 langkey="phAccountPayment_SectionLabel"></h2>
                <ng-container *ngIf="isAccountPaymentApproved">
                  <div class="account-payment-profile__credit-card">
                    <div class="account-payment-profile__card-title" *ngIf="accountPaymentCustomer?.creditRangeLabel">
                      {{accountPaymentCustomer.creditRangeLabel}}
                    </div>
                    <div class="account-payment-profile__credit-row">
                      <span>{{accountPaymentCustomer?.creditLimitLabel}}</span>
                      <span>{{formatCurrency(accountPaymentCreditValues?.limit || 0)}}</span>
                    </div>
                    <div class="account-payment-profile__credit-row account-payment-profile__credit-row--used">
                      <span>{{accountPaymentCustomer?.usedBalanceLabel}}</span>
                      <span>{{formatCurrency(accountPaymentCreditValues?.usedBalance || 0)}}</span>
                    </div>
                    <div class="account-payment-profile__progress-bar-container">
                      <div class="account-payment-profile__progress-bar" [style.width.%]="accountPaymentUsedPercent">
                      </div>
                    </div>
                    <div class="account-payment-profile__credit-row account-payment-profile__credit-row--available">
                      <span>{{accountPaymentCustomer?.availableLabel}}</span>
                      <span
                        class="account-payment-profile__available-amount">{{formatCurrency(accountPaymentCreditValues?.available
                        || 0)}}</span>
                    </div>
                    <div *ngIf="accountPaymentCustomer?.availableCreditAutoUpdate"
                      class="account-payment-profile__footnote">
                      {{accountPaymentCustomer.availableCreditAutoUpdate}}
                    </div>
                  </div>
                </ng-container>
                <div class="account-payment-profile__limit-reached"
                  *ngIf="accountPaymentCustomer && isAccountPaymentApproved && isAccountPaymentLimitReached">
                  <div class="account-payment-profile__warning-icon inline-icon"
                    inlineSVG="shop-icons.svg#ya-hypersoft-achtung"></div>
                  <div class="account-payment-profile__limit-reached-text">
                    <span>{{accountPaymentCustomer.usedBalanceLabel}}</span>
                    <span
                      class="account-payment-profile__amount">{{formatCurrency(accountPaymentCreditValues?.usedBalance
                      || 0)}}</span>
                    <span>{{accountPaymentCustomer.limitReachedPaymentBlockedHint}}</span>
                  </div>
                </div>
                <ng-container *ngIf="!isAccountPaymentApproved">
                  <ng-container *ngIf="showActivationInfoBox">
                    <div class="account-payment-profile__activation-info">
                      <span class="account-payment-profile__status-text"
                        *ngIf="showAccountPaymentPendingStatus">{{accountPaymentCustomer?.activationPendingStatus}}</span>
                      <span class="account-payment-profile__description-text"
                        *ngIf="activationDescription">{{activationDescription}}</span>
                    </div>
                  </ng-container>
                  <div class="ya-webshop-button-container account-payment-profile__request-btn"
                    *ngIf="canRequestActivation">
                    <button a11y_Button mat-flat-button [disabled]="activationRequestInProgress"
                      (click)="openAccountPaymentRequestDialog()">
                      <span langkey="phAccountPayment_ButtonRequestActivation"></span>
                    </button>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-template>
        </mat-tab>
      </ng-container>
      <!--End Account Payment Tab -->
    </mat-tab-group>
  </div>
</div>